import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface BreadcrumbNavigationProps {
  courseName?: string;
  hasUnsavedChanges: boolean;
  isLoading: boolean;
  isReordering: boolean;
  onBack: () => void;
  onUpdateCourse: () => void;
  isEditing: boolean;
}

export const BreadcrumbNavigation: React.FC<BreadcrumbNavigationProps> = ({
  courseName,
  hasUnsavedChanges,
  isLoading,
  isReordering,
  onBack,
  onUpdateCourse,
  isEditing
}) => {
  return (
    <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-3 z-10">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button 
            onClick={onBack}
            className="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </button>
          <span className="text-gray-400">|</span>
          <span className="text-gray-900 font-medium">
            {courseName || (isEditing ? 'Edit Golf Course' : 'Add Golf Course')}
          </span>
        </div>
        
        <div className="flex items-center space-x-4">
          {hasUnsavedChanges && (
            <div className="flex items-center text-amber-600">
              <div className="w-2 h-2 bg-amber-500 rounded-full animate-pulse mr-2"></div>
              <span className="text-sm">Unsaved changes</span>
            </div>
          )}
          <button 
            onClick={onUpdateCourse}
            disabled={!hasUnsavedChanges || isLoading || isReordering}
            className={`px-4 py-2 rounded-md transition-all ${
              hasUnsavedChanges 
                ? 'bg-amber-600 hover:bg-amber-700 text-white' 
                : 'bg-gray-100 text-gray-400 cursor-not-allowed'
            }`}
          >
            {isLoading ? 'Saving...' : (isEditing ? 'Update Course' : 'Create Course')}
          </button>
        </div>
      </div>
    </div>
  );
};